import React, { useContext, useState } from 'react';
import { Table } from 'reactstrap';
import PropTypes from 'prop-types';
import Popup from '../../components/popup/Popup';
import FetchStatus from '../../components/fetchStatus/FetchStatus';
import MyBadge from '../../components/myBadge/MyBadge';
import PopupConfirmation from '../../components/popup/PopupConfirmation';
import AttendanceApprovalTable from './AttendanceApprovalTable';
import { showToast } from '../../components/toast/Toast';
import DayView from '../../components/dayView/DayView';
import useAxios from '../../hooks/useAxios';
import Pagination from '../../components/pagination/Pagination';
import OverviewAttendanceRequest from '../admin/request/OverviewAttendanceRequest';
import { AuthContext } from '../../context/AuthContext';
import getRowNumber from '../../utils/getRowNumber';

const menus = [
  {
    id: 1,
    label: 'Ringkasan',
    allowedRoles: ['1024'],
  },
  {
    id: 2,
    label: 'Approval',
    allowedRoles: ['1024'],
  },
];

const AttendanceTab1 = ({ isLoading, error, listData, metaData, refetch, setLimit, setPage }) => {
  const { auth } = useContext(AuthContext);
  const [cancelPopup, setCancelPopup] = useState(false);
  const [detailPopup, setDetailPopup] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const [selectedId, setSelectedId] = useState(undefined);
  const [selectedData, setSelectedData] = useState(undefined);
  const [menuActive, setMenuActive] = useState(1);

  const api = useAxios();

  const toggleCancelPopup = (id) => {
    setCancelPopup(!cancelPopup);
    setSelectedId(id);
  };

  const toggleDetailPopup = (item) => {
    setDetailPopup(!detailPopup);
    setSelectedId(item?.id);
    setSelectedData(item);
  };

  const handleCancel = async () => {
    setCanceling(true);
    await api
      .post(`/request-attendance/${selectedId}/cancel`)
      .then(() => {
        refetch();
        showToast('Pengajuan absensi berhasil dibatalkan', 'success');
      })
      .catch((err) => {
        showToast(`Terjadi kesalahan. ${err.response.data.message}`, 'error');
      })
      .finally(() => {
        setCanceling(false);
        setCancelPopup(false);
      });
  };

  const handleMenu = (id) => {
    setMenuActive(id);
  };

  return (
    <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
      {isLoading ? (
        <FetchStatus type="loading" />
      ) : error ? (
        <FetchStatus type="error" />
      ) : listData?.length > 0 ? (
        <Table responsive hover>
          <thead>
            <tr>
              <th style={{ textAlign: 'center', minWidth: '50px' }}>No.</th>
              <th style={{ textAlign: 'center', minWidth: '160px' }}>Dibuat pada</th>
              <th style={{ textAlign: 'center', minWidth: '160px' }}>Tanggal Absen</th>
              <th style={{ textAlign: 'center', minWidth: '150px' }}>Jam Masuk (WIB)</th>
              <th style={{ textAlign: 'center', minWidth: '150px' }}>Jam Pulang (WIB)</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Status</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {listData?.map((item, idx) => (
              <tr key={item.id}>
                <td style={{ verticalAlign: 'middle' }} align="center">
                  {getRowNumber(idx, metaData)}
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  <DayView date={item.created_at} time />
                </td>
                <td style={{ verticalAlign: 'middle' }} align="center">
                  <DayView date={item.date} />
                </td>
                <td style={{ verticalAlign: 'middle' }} align="center">
                  {item.clock_in ? item.clock_in : '-'}
                </td>
                <td style={{ verticalAlign: 'middle' }} align="center">
                  {item.clock_out ? item.clock_out : '-'}
                </td>
                <td style={{ verticalAlign: 'middle' }} align="center">
                  {item.status === 'pending' && <MyBadge color="blue">Pending</MyBadge>}
                  {item.status === 'approved' && <MyBadge color="green">Approved</MyBadge>}
                  {item.status === 'rejected' && <MyBadge color="red">Rejected</MyBadge>}
                  {item.status === 'cancelled' && <MyBadge color="purple">Cancelled</MyBadge>}
                  {item.status === 'ignored' && <MyBadge color="yellow">Cancelled</MyBadge>}
                </td>
                <td align="center" width="170">
                  <div className="d-flex gap-2 justify-content-center">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm rounded-4"
                      onClick={() => toggleDetailPopup(item)}
                    >
                      Detail
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-4"
                      disabled={item.status !== 'pending'}
                      onClick={() => toggleCancelPopup(item.id)}
                    >
                      Cancel
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <FetchStatus type="empty" info="pengajuan absensi" />
      )}

      <Pagination meta={metaData} setLimit={setLimit} setPage={setPage} />

      <PopupConfirmation
        isOpen={cancelPopup}
        loading={canceling}
        toggle={toggleCancelPopup}
        handleConfirm={handleCancel}
        btnType="btn-danger"
        title="Konfirmasi Pembatalan"
        message="Apakah Anda yakin akan membatalkan pengajuan ini?"
      />
      <Popup
        isOpen={detailPopup}
        togglePopup={toggleDetailPopup}
        title="Detail Pengajuan Absensi"
        maxHeight={selectedData?.unplanned_reason_require_photo}
        isOverflow={selectedData?.unplanned_reason_require_photo}
      >
        <div className="d-flex gap-3">
          <div className="d-flex flex-column gap-2" style={{ width: '120px' }}>
            {menus.map(
              (item) =>
                auth?.roles.includes(item.allowedRoles[0]) && (
                  <div
                    key={item.id}
                    onClick={() => handleMenu(item.id)}
                    className={`btn btn-${
                      menuActive === item.id ? 'info' : 'outline-info'
                    } rounded-3 align-items-start d-flex block btn-sm`}
                  >
                    {item.label}
                  </div>
                ),
            )}
          </div>
          <div style={{ width: '85%' }}>
            {menuActive === 1 && <OverviewAttendanceRequest {...{ selectedData }} />}
            {menuActive === 2 && <AttendanceApprovalTable id={selectedId} />}
          </div>
        </div>
      </Popup>
    </div>
  );
};

AttendanceTab1.propTypes = {
  isLoading: PropTypes.bool,
  listData: PropTypes.array,
  metaData: PropTypes.object,
  error: PropTypes.any,
  refetch: PropTypes.func,
  setLimit: PropTypes.func,
  setPage: PropTypes.func,
};

export default AttendanceTab1;
